
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 135576","transform":"translate(-.425)"}},[_c('rect',{attrs:{"data-name":"Rectangle 111408","width":"46","height":"46","rx":"12","transform":"translate(.425)","fill":"#02363d","opacity":".1"}}),_c('g',{attrs:{"data-name":"Group 135571"}},[_c('g',{attrs:{"fill":"none","stroke":"#113239","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/profile-2user"}},[_c('path',{attrs:{"d":"M20.112 21.681a2.121 2.121 0 00-.385 0 5.186 5.186 0 11.385 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M28.57 13.667a4.08 4.08 0 014.083 4.083 4.089 4.089 0 01-3.935 4.084 1.318 1.318 0 00-.3 0","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.279 25.985c-2.823 1.89-2.823 4.97 0 6.848a11.394 11.394 0 0011.678 0c2.823-1.89 2.823-4.97 0-6.848a11.447 11.447 0 00-11.678 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M30.822 32.333a5.643 5.643 0 002.287-1.015 2.955 2.955 0 000-4.985 5.8 5.8 0 00-2.252-1","opacity":".4"}})])])])])
          )
        }
      }
    